import React, { useEffect, useState, Fragment } from 'react';
import axios from "axios";
import styles from './education.module.scss';
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';
import { dataConvertOverview } from '../../utils/overall-convert';
import { educ1Overview } from '../../data/data-education-tab1';
// import UseData from '../../hooks/useData.js';

const options = [
  { label: "Total opportunity score", value: "total" },
  { label: "Earning potential", value: "project" },
  { label: "Career advancement", value: "career" },
  { label: "Top-tier employment prospects", value: "employ" },
  { label: "Premium education", value: "edu" },
  { label: "Economic mobility", value: "econ" },
  { label: "High livability", value: "liva" },
];

const Education = () => {
  const [sortColumn, setSortColumn] = useState("total");
  // const [display, setDisplay] = useState();
  // const [countryCount, setCountryCount] = useState(1);
  const [projectCount, setProjectCount] = useState(1);
  const [careerCount, setCareerCount] = useState(1);  
  const [employCount, setEmployCount] = useState(1);
  const [eduCount, setEduCount] = useState(1);
  const [econCount, setEconCount] = useState(1);
  const [livaCount, setLivaCount] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  
  const [dataEduc1Overview, setDataEduc1Overview] = useState(null);

  let baseApiUrl = "https://api.henleypassportindex.com/api/";

  if (window['__hpi_url__'] !== undefined) {
      baseApiUrl = window['__hpi_url__'];
  }

  
  const data_url = baseApiUrl +  'v2/ultimate-portfolio/portfolio';

  const fetchData = async () => {

    const requestData  = await axios.get(data_url);
    const requestResult = requestData.data;
    
    if (requestResult) {
      const jsondata  = educ1Overview.map((d) => {
        const cityInRequest = requestResult.find((c) => d.country === c.country || d.country === c.iso_code);
        
        const calOfLivability = ((Number(cityInRequest.private_healthcare) + 
                                  Number(cityInRequest.lifestyle) + 
                                  Number(cityInRequest.safety_security)) / 3);
        
        
        const calOfTotal = ((d.career + d.project + d.employ + Number(cityInRequest.education) + 
                            Number(cityInRequest.economic_mobility) + calOfLivability) / 6);
        return {
          country: d.country,
          career: d.career, 
          project: d.project,
          employ: d.employ,
          edu: cityInRequest.education,
          econ: cityInRequest.economic_mobility,
          liva: Math.round(calOfLivability),
          total: Math.round(calOfTotal),
          // rank: d.rank
        }
      }).sort((a, b) => b.total - a.total);

      setDataEduc1Overview(jsondata);
      
    }
    
  };
  
    
  useEffect(() => {
      fetchData();
  }, []);
  
  // const dataEduc1Overview = () => {
  //   return dataConvertOverview(educ1Overview);
  // }
  // const dataEduc1Overview  = () =>  UseData();
  
  const handleOptionSelect = (option) => {
    // setSelectedOption(option);
    setSortColumn(option.value);
    // setDisplay(-1);
  };
  
  const handleSort = (columnName) => {
    switch (columnName) {
      // case 'country':
      //   (countryCount === 1) ? setCountryCount(-1) : setCountryCount(1);
      //   break;
      case 'project':
        (projectCount === 1) ? setProjectCount(-1) : setProjectCount(1);
        break;
      case 'career':
        (careerCount === 1) ? setCareerCount(-1) : setCareerCount(1);
        break;
      case 'employ':
        (employCount === 1) ? setEmployCount(-1) : setEmployCount(1);
        break;
      case 'edu':
        (eduCount === 1) ? setEduCount(-1) : setEduCount(1);
        break;
      case 'econ':
        (econCount === 1) ? setEconCount(-1) : setEconCount(1);
        break;
      case 'liva':
        (livaCount === 1) ? setLivaCount(-1) : setLivaCount(1);
        break;
      case 'total':
        (totalCount === 1) ? setTotalCount(-1) : setTotalCount(1);
        break;
      default:
        break;
    }
    setSortColumn(columnName);
    // setDisplay(-1);
  };
  
  const reverseSortNum = (columnName, count) => {
    if (dataEduc1Overview === null) 
      return null;
    
    return (count === 1) ?
      dataEduc1Overview.sort((a, b) => b[columnName] - a[columnName])
      : dataEduc1Overview.sort((a, b) => a[columnName] - b[columnName]);
  }
  
  const handleSortingOptions = (columnName) => {
    switch (columnName) {
      // case 'country':
      //   return (countryCount === 1) ?
      //     dataEduc1Overview().sort((a, b) => b[columnName].localeCompare(a[columnName]))
      //     : dataEduc1Overview().sort((a, b) => a[columnName].localeCompare(b[columnName]));
      case 'project':
        return reverseSortNum(columnName, projectCount);
      case 'career':
        return reverseSortNum(columnName, careerCount);
      case 'employ':
        return reverseSortNum(columnName, employCount);
      case 'edu':
        return reverseSortNum(columnName, eduCount);
      case 'econ':
        return reverseSortNum(columnName, econCount);
      case 'liva':
        return reverseSortNum(columnName, livaCount);
      case 'total':
        return reverseSortNum(columnName, totalCount);
      default:
        break;
    }
  }
  
  const sortedData = sortColumn && (dataEduc1Overview !== null)
    ? handleSortingOptions(sortColumn)
    : dataEduc1Overview;


  return (
    <>
      {/* <h3 className="mb-5">The Henley Opportunity Index</h3> */}
      <div className={`d-md-none ${styles.sortMobileWrapper}`}>
        <div className={styles.sortTitle}>Sort by</div>
        <SelectDropdown options={options} onSelect={handleOptionSelect} />
      </div>
      <table className={`chartTable ${styles.overviewChartTable}`} >
        <thead>
          <tr>
            {/* <th className={styles.cityColumn} >City/Area</th> */}
            <th className={styles.cityColumn} >Country</th>
            {/* <th
              className={`text-left ${styles.cellHideMobile} ${styles.countryColumn} ${styles.sortableColumn} ${sortColumn === 'country' ? styles.selectedColumn : ''}`}
              onClick={() => handleSort("country")}
            >
              <div className={styles.sortColumnTitle}>
                {(countryCount === 1) ? <IconSort /> : <ReverseIconSort />}
                <span className={styles.sortColumnTitleText}>Country</span>
              </div>
            </th> */}
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortColumn === 'project' ? styles.selectedColumn : ''}
                              ${sortColumn === 'project' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("project")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Earning potential</span>
                {(projectCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortColumn === 'career' ? styles.selectedColumn : ''}
                              ${sortColumn === 'career' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("career")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Career advancement</span>
                {(careerCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortColumn === 'employ' ? styles.selectedColumn : ''}
                              ${sortColumn === 'employ' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("employ")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Top-tier employment prospects</span>
                {(employCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortColumn === 'edu' ? styles.selectedColumn : ''}
                              ${sortColumn === 'edu' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("edu")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Premium education</span>
                {(eduCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortColumn === 'econ' ? styles.selectedColumn : ''}
                              ${sortColumn === 'econ' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("econ")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Economic mobility</span>
                {(econCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortColumn === 'liva' ? styles.selectedColumn : ''}
                              ${sortColumn === 'liva' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("liva")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>High livability</span>
                {(livaCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.progressBarColumn}
                              ${sortColumn === 'total' ? styles.selectedColumn : ''}
                              ${sortColumn === 'total' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("total")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Total opportunity score</span>
                {(totalCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            {/* <th className={`text-right ${styles.cellHideMobile}`}>Investment <br/>migration options</th> */}
          </tr>
        </thead>
        <tbody>
          {sortedData && sortedData.map((item, index) => (
          // {sortedData.slice(0, numOfCitiesShow).map((item, index) => (
            <Fragment key={index}>
              <tr className={`${styles.contentRow} ${styles.openedRow}`}>
                {/* <tr onClick={() => handleMobileRowClick(index)} className={`${styles.contentRow} ${index === display ? styles.openedRow : ''}`}> */}
                {/* <td>{item.city}</td> */}
                <td><CountryFlag country={item.country} /></td>
                {/* <td className={`text-left 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${sortColumn === 'country' ? styles.selectedColumn : ''}
                              `}>
                  <CountryFlag country={item.country} />
                </td> */}
                <td className={`text-right 
                                            ${styles.hiddenTableRow} 
                                            ${styles.sortableColumn} 
                                            ${styles.combinateRowCells} 
                                            ${sortColumn ? styles.selectedColumn : ''} 
                                            ${sortColumn === 'total' ? styles.percentColumn : ''}
                                          `}>
                  {sortColumn === "total" ?
                    <ProgressBar
                      percentValue={item.total > 0 ? item.total : 0}
                      labelText={formatNumberWithDot(item.total) + "%"}
                    />
                    : formatNumberWithDot(item[sortColumn])
                  }
                </td>
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'project' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.project)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'career' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.career)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'employ' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.employ)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'edu' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.edu)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'econ' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.econ)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'liva' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.liva)}
                </td>

                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'total' ? styles.percentColumn : ''}
                                ${sortColumn === 'total' ? styles.selectedColumn : ''}
                              `}>
                  <ProgressBar
                    percentValue={item.total > 0 ? item.total : 0}
                    labelText={formatNumberWithDot(item.total) + "%"}
                  />
                </td>
                {/* <td className={`text-right ${styles.cellHideMobile}`}>
                                  {item.link && (
                                      <a href={item.link} target="_blank" className={styles.linkText} rel="noreferrer">Find out more</a>
                                  )}
                                  
                              </td> */}
              </tr>
              {/* <tr className={`${styles.hiddenTableRow}`}>
                <td className={`${styles.countryMobileDiv}`}>
                  <CountryFlag country={item.country} />
                </td>
              </tr> */}
            </Fragment>
          ))}
        </tbody>
      </table>
      {/* <div className="footer-note mt-5">
        <ul>
          <li>Figures for June 2023.</li>
          <li>Only includes individuals living in each city (residents).</li>
          <li>'Centi-millionaires' refers to individuals with investable wealth of USD 100 million or more.</li>
        </ul>
        <p>Source: New World Wealth</p>
      </div> */}
    </>
  )
}

export default Education;